import { getAuth } from 'firebase/auth';

export async function fetchAIProse(validatedData, insightPacket, signal) {
  const auth = getAuth();
  const uid  = auth.currentUser?.uid ?? null;

  // Build briefing from explicit allowlist — no _scrubAudit, no _validated,
  // no fields beyond what the server needs. PII can't leak through here.
  const briefing = {
    repName:              validatedData.repName,
    reportingMonth:       validatedData.reportingMonth,
    reportingYear:        validatedData.reportingYear,
    unitsSold:            validatedData.unitsSold,
    goal:                 validatedData.goal,
    goalAttainment:       validatedData.goalAttainment,
    paceToGoal:           validatedData.paceToGoal,
    sellingDaysElapsed:   validatedData.sellingDaysElapsed,
    sellingDaysRemaining: validatedData.sellingDaysRemaining,
    commissionMTD:        validatedData.commissionMTD,
    avgGrossPerUnit:      validatedData.avgGrossPerUnit,
    totalOutreach:        validatedData.totalOutreach,
    leadsContacted:       validatedData.leadsContacted,
    leadConversionRate:   validatedData.leadConversionRate,
    apptSetRate:          validatedData.apptSetRate,
    apptShowRate:         validatedData.apptShowRate,
    apptCloseRate:        validatedData.apptCloseRate,
    dataQuality:          validatedData.dataQuality,
    archetype:            insightPacket.archetype,
    bottleneck:           insightPacket.bottleneck,
    forecast:             insightPacket.forecast,
  };

  const response = await fetch('/api/insights', {
    method: 'POST',
    signal,  // AbortController signal — cancel on panel close
    headers: {
      'Content-Type': 'application/json',
      ...(uid ? { 'x-uid': uid } : {}),
    },
    body: JSON.stringify({ briefing }),
  });

  if (!response.ok) {
    if (response.status === 429) throw new Error('RATE_LIMITED');
    throw new Error(`Server error: ${response.status}`);
  }

  const data = await response.json();
  return data.prose ?? null;  // null → templateProse fallback in hook
}
